import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountListComponent } from './account-list/account-list.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { RouterModule } from '@angular/router';
import { HomeModule } from '../home/home.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PolicyListByAccountComponent } from './policy-list-by-account/policy-list-by-account.component';
import { DirectBillByAccountComponent } from './direct-bill-by-account/direct-bill-by-account.component';
import { ClaimListByAccountComponent } from './claim-list-by-account/claim-list-by-account.component';
import { HeaderModule } from '../header/header.module';
import { AccountActivityComponent } from './account-activity/account-activity.component';
import { PolicyActivityComponent } from './policy-activity/policy-activity.component';
import { NegativeCurrencyPipe } from '../_pipes/negative-currency.pipe';
import { AccountEndorsementHistoryComponent } from './account-endorsement-history/account-endorsement-history.component';
import { MrReportingDetailsComponent } from './mr-reporting-details/mr-reporting-details.component';
import { DocumentByAccountComponent } from './document-by-account/document-by-account.component';

@NgModule({
  declarations: [
    AccountListComponent,
    PolicyListByAccountComponent,
    DirectBillByAccountComponent,
    ClaimListByAccountComponent,
    AccountActivityComponent,
    PolicyActivityComponent,
    NegativeCurrencyPipe,
    AccountEndorsementHistoryComponent,
    MrReportingDetailsComponent,
    DocumentByAccountComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    RouterModule,
    HeaderModule,
    HomeModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class AccountModule { }
